import { useEffect, useState } from 'react'

export const DESKTOP_MEDIA_QUERY = '(min-width: 768px)'

function mediaQueryMatches(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia(DESKTOP_MEDIA_QUERY).matches
}

/**
 * D-053 splits the refresh affordance by layout: below 768 px the screen uses
 * pull-to-refresh and renders no refresh button; at 768 px and above the
 * explicit refresh control is visible. The listener keeps the affordance in
 * sync when the viewport is resized.
 */
export function useIsDesktop(): boolean {
  const [desktop, setDesktop] = useState(mediaQueryMatches)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const query = window.matchMedia(DESKTOP_MEDIA_QUERY)
    const update = () => setDesktop(query.matches)
    update()
    query.addEventListener?.('change', update)
    return () => query.removeEventListener?.('change', update)
  }, [])

  return desktop
}

/** Debounce for the friends search (300 ms, UI_PARITY §3.13). */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [delayMs, value])

  return debounced
}
